import { Callout, Intent } from '@blueprintjs/core'
import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router'
import { ConnectedMarket } from '../current/types'
import { usePermissions } from '../hooks/usePermissions'
import { AppState } from '../store'

interface LinkWarning extends ConnectedMarket {
  intent: Intent
  message: string
}

function buildLinkingList(connectedMarkets: ConnectedMarket[]): LinkWarning[] {
  const output = []
  const seen = new Set()
  connectedMarkets
    .sort((a, b) => Number(a.onboarded) - Number(b.onboarded)) // sort by required relinks first
    .filter(cm => cm.name !== 'facebook') // facebook is deprecated
    .forEach(cm => {
      if (seen.has(cm.name)) return
      if (!cm.shouldRelink) return

      if (cm.onboarded === false) {
        seen.add(cm.name)
        output.push({
          ...cm,
          intent: Intent.DANGER,
          message: 'needs to be relinked'
        })
      }

      if (cm.onboarded && cm.shouldRelink) {
        seen.add(cm.name)
        output.push({
          ...cm,
          intent: Intent.WARNING,
          message: 'should be relinked'
        })
      }
    })

  return output
}

export default () => {
  const { permissions } = usePermissions()
  if (!permissions.includes('settings.channels')) return null

  const connectedMarkets = useSelector((s: AppState) => s.current.organization.connectedMarkets)
  const warnings = buildLinkingList(connectedMarkets)

  if (warnings.length <= 0) return null

  return (
    <>
      {warnings.map(lw => (
        <Callout key={lw.marketAccountId} intent={lw.intent} className="screen-only" data-testid={`${lw.name}-callout`}>
          {lw.humanReadableName} {lw.message}. <Link to={`/admin/${lw.name}`}>Go to settings</Link>
        </Callout>
      ))}
    </>
  )
}
